import React from 'react';
import ReactDOM from 'react-dom';
import { SpeechProvider } from '@speechly/react-client';
import { Provider } from './context/context';
import App from './App';
import './index.css';


ReactDOM.render(
  <SpeechProvider appId="a9b1cb1f-5ab8-4407-9934-dabf075bb145" language="en-US">
    <Provider>
      <App />
    </Provider>
    
  </SpeechProvider>,
  document.getElementById('root'),
);